import React, { useEffect, useState } from 'react'
import {useAddTeamMutation} from "../../../features/teams/teamsApi";
import { useSelector } from "react-redux";
import {useAddProjectMutation} from "../../../features/projects/projectsApi";
import {useGetTeamsQuery} from "../../../features/teams/teamsApi";





const Modal = ({setShowModal}) => {


const [addProject, {isLoading, isSuccess }] =useAddProjectMutation();
const { user: loggedInUser } = useSelector((state) => state.auth) || {};
const { data } = useGetTeamsQuery(loggedInUser.id) || {};
const [title,setTitle]=useState('');
const [team,setTeam]=useState('');


  const handleSubmit = (e)=>{
       e.preventDefault();
       addProject(
        { id:loggedInUser.id.toString(), 
          data:{
              title,
              teamId:team,
              created:new Date().toLocaleString(),
              creatorId:loggedInUser.id,
              creatorImg:loggedInUser.image,
              stage:'backlog'
          }
        });
  }  
  
  useEffect(() => {
    if (isSuccess) {
        setTitle("");
        setTeam("");
    }
  }, [isSuccess]);

  return (
    <>
    <div
      className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
    >
      <div className="relative w-auto my-6 mx-auto max-w-3xl">
        {/*content*/}
        <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
          {/*header*/}
          <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
            <h3 className="text-3xl font-semibold">
              {isLoading ? 'Loading':'Add Project'}
            </h3>
              {isSuccess && 
                <h3 className='text-green-500 mt-2'>Added</h3>
              }
          </div>
          {/*body*/}
          <div className="relative p-6 flex-auto">
            <form className="w-full max-w-lg" onSubmit={handleSubmit}>
                <div className="flex flex-wrap -mx-3 mb-6">
                    <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-first-name">
                        Project Title
                    </label>
                    <input onChange={(e) =>setTitle(e.target.value)}  value={title} required className="appearance-none block w-full bg-gray-200 text-gray-700  border border-gray-200  rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" id="grid-first-name" type="text" placeholder="Project Title"/>
                    </div>
                    <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
                        Assign a Team
                    </label>
                    <div className="relative">
                        <select onChange={(e) =>setTeam(e.target.value)}  value={team} required className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-state">
                        <option value=''>Select</option>
                        {
                            data && data.length > 0 && data.map((value,i)=>(
                            <option className={value.color} key={i} value={value.id}>{value.name}</option>
                            ))
                        }
                        </select>
                        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                        <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                        </div>
                    </div>
                    </div>
                </div>

                <div className="flex items-center justify-end border-t border-solid border-slate-200 rounded-b">
                  <br/>
                  <br/>
                  <br/>
                  <button
                    className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => setShowModal(false)}
                  >
                    Close
                  </button>
                  <button
                    className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="submit"
                  >
                    Add project
                  </button>
                </div>
          </form>
          </div>
        </div>
      </div>
    </div>
    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
  </>
  )
}

export default Modal